import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SOURCES = { par_grid: 'PAR Grid', stock_item_form: 'Stock item form', import: 'Import' };

export const ParHistory = ({ branches, isAdmin, refreshKey }) => {
  const [rows, setRows] = useState([]);
  const [branchId, setBranchId] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/par-values/history`, { withCredentials: true, params: branchId ? { branch_id: branchId } : {} })
      .then((r) => setRows(r.data)).catch(() => toast.error('Failed to load history'));
  }, [branchId, refreshKey]);

  const q = search.toLowerCase();
  const shown = rows.filter((r) => !q || r.item_name?.toLowerCase().includes(q) || r.changed_by?.toLowerCase().includes(q));

  return (
    <div className="space-y-4" data-testid="par-history">
      <div className="flex gap-3">
        {isAdmin && (
          <Select value={branchId || 'all'} onValueChange={(v) => setBranchId(v === 'all' ? '' : v)}>
            <SelectTrigger className="w-52" data-testid="par-history-branch-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All branches</SelectItem>
              {branches.map((b) => <SelectItem key={b.branch_id} value={b.branch_id}>{b.name}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
        <Input className="w-64" placeholder="Search item or person" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="par-history-search" />
      </div>
      <Card>
        <CardContent className="p-0">
          {shown.length === 0 ? (
            <p className="text-center text-muted-foreground py-10" data-testid="par-history-empty">No PAR changes recorded yet.</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>When</TableHead>
                  <TableHead>Item</TableHead>
                  <TableHead>Branch</TableHead>
                  <TableHead className="text-center">PAR</TableHead>
                  <TableHead>Changed by</TableHead>
                  <TableHead>Where</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {shown.map((r) => (
                  <TableRow key={r.history_id} data-testid={`par-history-row-${r.history_id}`}>
                    <TableCell className="text-sm whitespace-nowrap">{new Date(r.changed_at).toLocaleString()}</TableCell>
                    <TableCell className="font-medium">{r.item_name}</TableCell>
                    <TableCell>{r.branch_name}</TableCell>
                    <TableCell className="text-center whitespace-nowrap tabular-nums">
                      <span className="text-muted-foreground">{r.old_par}</span> → <strong>{r.new_par}</strong>
                    </TableCell>
                    <TableCell>{r.changed_by}</TableCell>
                    <TableCell><Badge variant="secondary">{SOURCES[r.source] || r.source}</Badge></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
